<template>
  <div class="cooperation-add-wrapper global-card">
    <bread-crumb />
    <div class="form-card-wrapper">
      <a-card
        :bordered="false"
        style="width: 100%;border-radius:10px;"
      >
        <form-card
          ref="formcard1"
          title="协议内容"
          :form-data="formData1"
          class="agreement-class"
        >
          <template #name>
            <a-input
              v-decorator="['name', { initialValue: data1.name }]"
              disabled
            />
          </template>
          <template #title>
            <a-input
              v-decorator="[
                'title',
                {
                  rules: [{ required: true, message: '请输入协议标题' }],
                  initialValue: data1.title,
                },
              ]"
              :disabled="isDisabled"
            />
          </template>
          <template #service_provider_id>
            <a-select
              v-decorator="[
                'service_provider_id',
                {
                  rules: [{ required: true, message: '请选择执行方' }],
                  initialValue: data1.service_provider_id,
                },
              ]"
              :disabled="isDisabled"
              placeholder="请选择执行方"
            >
              <a-select-option
                v-for="item in serviceData"
                :key="item.id"
                :value="item.id"
              >
                {{ item.companyInfo.qichacha_name }}
              </a-select-option>
            </a-select>
          </template>

          <template #link_products>
			  <div style="height: 30px;"></div>
            <a-select
              v-decorator="[
                'link_products',
                {
                  rules: [{ required: true, message: '请选择关联产品' }],
                  initialValue: data1.link_products,
                },
              ]"
              :disabled="isDisabled"
              @change="getproductsId"
            >
              <a-select-option
                v-for="item in productsData"
                :key="item.id"
                :value="item.id"
              >
                {{ item.title }}
              </a-select-option>
            </a-select>
          </template>
		  <template #datas>
			  <div style="height: 30px;"></div>
		    <a-select
		      v-decorator="[
		        'datas',
		        {
		          rules: [{ required: true, message: '请选择关联资料' }],
		          initialValue: data1.datas,
		        },
		      ]"
		      :disabled="isproductsDataDisabled"
			    @change="getdatasdinfo"
		      mode="multiple"
		    >
		      <a-select-option
		        v-for="item in datasData"
		        :key="item.id"
		        :value="item.id"
				:code="item.type"
		      >
		        {{ item.name }}
		      </a-select-option>
		    </a-select>
		  </template>
          <template #money>
            <service-money
              v-decorator="[
                'money',
                {
                  initialValue: data1.money,
                  rules: [{ required: true, message: '请输入预算' }],
                },
              ]"
              :disabled="isDisabled"
            />
          </template>
          <template #province_city>
            <province-city
              v-decorator="[
                'province_city',
                {
                  rules: [{ required: true, validator: checkProvinceCity }],
                  initialValue: data1.province_city,
                },
              ]"
              :pro-and-city-disabled="isDisabled"
            />
          </template>
          <template #service_time>
            <a-range-picker
              v-decorator="[
                'service_time',
                {
                  rules: [
                    { required: true, message: '请选择协议开始和结束日期' },
                  ],
                  initialValue: data1.service_time,
                },
              ]"
              :disabled="isDisabled"
              style="width: 100%;"
            />
          </template>
        </form-card>
        <form-card
          ref="formcard2"
          title="协议服务"
          :form-data="formData2"
        >
          <template #type>
            <div>
              勾选服务项目
              <span class="error-note">{{ errorMsg }}</span>
            </div>
            <div
              v-for="(item, index) in data2"
              :key="item.id"
              style="display:flex; min-height:100px;padding:0 20px;background:#F9F9FC;margin-bottom:20px;"
            >
              <div style="flex-grow:1">
                <div>
                  <a-checkbox
                    :disabled="isDisabled"
                    :checked="servicesChecks.find(check=>check.id===item.id).value"
                    @change="handleChange(item.id, index)"
                  >
                    {{ item.name }}
                  </a-checkbox>
                </div>
                <div
                  style="margin-top:3px;color:#C3C7D5;font-size:14px;padding:0 0 0 20px;margin-bottom:0;line-height:10px;"
                >
                  {{ item.summary }}
                </div>
              </div>
              <div
                style="flex-grow:0;width:200px;display:flex;justify-content:center;align-items:center;"
              >
                <div>
                  <a-input
                    v-decorator="[
                      `${item.id}`,
                      {
                        initialValue: `${item.money}`,
                      },
                    ]"
                    :disabled="isDisabled"
                    :min="1"
                    type="number"
                    addon-after="元/次"
                    placeholder="预算价格"
                  />
                </div>
              </div>
            </div>
          </template>
        </form-card>
        <form-button
          :btn-is-loading="btnIsLoading"
          class="form-card-button"
          @onCancel="onCancel"
          @onSubmit="onSubmit"
        />
      </a-card>
    </div>
  </div>
</template>
<script>
import { formData1, formData2, formData3 } from './../data';
import ServiceMoney from './../components/ServiceMoney';
export default {
  components: { ServiceMoney },
  data() {
    return {
	  isproductsDataDisabled:true,
      Status: undefined,
      formData1,
      formData2,
      formData3,
      data1: {
        name: '',
      },
      data2: [],
	  datasData:[],
      data3: { flag: 1 },
      serviceData: [],
      productsData: [],
	  dataArr:[],
      serviceList: [],
      servicesChecks: [],
      errorMsg: '',
      isDisabled: false,
      btnIsLoading: false,
    };
  },
  created() {
    this.$role = this.$store.state.user.role;
  },
  async mounted() {
    // 获取服务商
    await this.getServices();
    // 获取产品
    await this.getProducts();
    // 获取服务列表
    await this.getServiceList();
    // 回显
    if(this.$route.query.id){
      this.getAgreemntInfo({ id: this.$route.query.id });
    }else{
      this.getUser();
    }
  },
  methods: {
    // 表单回显
    async getAgreemntInfo(id) {
      let result = await this.$http.post('/agreement/show', id);
      if (result.data.status === 1) {
        let res = result.data.data;
			// this.getproductslist(res.agreement_product[0].id)
		this.isproductsDataDisabled=false
        this.data1 = {
          name: res.company_info.companyInfo.qichacha_name,
          title: res.title,
          service_provider_id: res.service_provider_id,
          link_products: res.agreement_product.map((item) => {
            return item.id;
          }),
		  datas:res.datas_map_ids,
          money: { budget: res.budget, deposit: res.deposit },
          province_city: { province: res.province, city: !res.city?undefined:res.city },
          service_time: [
            this.$moment.unix(res.service_start_time),
            this.$moment.unix(res.service_end_time),
          ],
        };
        // 回显
        this.servicesChecks = [];
        this.data2 = this.data2.map((item)=>{
          const match = res.agreement_service.find((service)=>service.id === item.id);
          let check = false;
          let money;
          if(match){
            check = true;
            money = match.budget;
          }
          this.servicesChecks.push({id: item.id, value: check});
          return {
            money,
            id: item.id,
            name: item.name,
            summary: item.summary,
          };
        });
        // 企业 status=3 意见
        if (this.$role === 0 && parseInt(this.Status) === 3) {
          this.data3 = {
            flag: 0,
            desc: res.confirm_desc_sp,
          };
        }
      }
    },
	async getproductsId(val){
		this.isproductsDataDisabled=false
		 this.$refs.formcard1.form.setFieldsValue({
		        'datas': []
		})
		this.getproductslist(val)
	},
	async getproductslist(val){
		let data={
			product_id:val
		}
		let result = await this.$http.post('/product/relations',data);
		if (result.data.status === 1) {
			this.datasData=result.data.data
		}
	},
	eventTypeChange (value, option) {
	    console.log(value)
	    },
    // 获取甲方信息
    async getUser() {
      let result = await this.$http.post('/manager/getCompanyManagerInfo');
      if (result.data.status === 1) {
        this.data1.name = result.data.data.company.team_name;
      }
    },
    // 获取服务商
    async getServices() {
      let result = await this.$http.post('/ServiceProvider/getCompanyList');
      if (result.data.status === 1) {
		  result.data.data.data_list.map(item=>{
			  if(item.companyInfo&&item.status===1){
				  this.serviceData.push(item)
			  }
		  })
        this.serviceData = result.data.data.data_list.filter((item)=>item.status===1);
		console.log(this.serviceData)
      }
    },
    // 获取产品
    async getProducts() {
      let result = await this.$http.post('/product/getList');
      if (result.data.status === 1) {
		  console.log(result.data.data.data_list)
        this.productsData = result.data.data.data_list.filter((item)=>item.status===1);
      }
    },

    // 获取服务列表
    async getServiceList() {
      let result = await this.$http.post('/Service/getList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list.filter((item)=>item.status===1);
        this.data2 = data.map((item) => {
          this.servicesChecks.push({id: item.id, value: false});
          return { ...item, money: '' };
        });
      }
    },
	getdatasdinfo(val){
		this.dataArr=val
	},
    // 提交
    async onSubmit() {
      let role = this.$role === 0;
      let url = '/agreement/update';
      // 新增协议
      let datas = {};
      let form1 = false;
      let service_budget;
      const link_services = [];
      this.$refs.formcard1.form.validateFields((err, values) => {
        console.log(1213);
        if (!err) {

          datas = Object.assign({}, values);
          form1 = true;
        }
      });
      this.$refs.formcard2.form.validateFields((err, values) => {
        console.log('TCL: onSubmit -> values', values);
        service_budget = values;
      });
      if (form1) {
        const hasCheck = this.servicesChecks.some((item) => item.value);
        if (!hasCheck) {
          return (this.errorMsg = '请选择服务项目');
        }
        this.servicesChecks.forEach((checked) => {
          if (checked.value) {
            link_services.push({
              service_id: checked.id,
              service_budget: Number(service_budget[checked.id]),
            });
          }
        });
        const hasBudget = link_services.some((item) => !!item.service_budget);
        if (!hasBudget) {
          return (this.errorMsg = '请完善服务项目');
        }
        this.errorMsg = '';
		console.log(typeof(datas.link_products))
        let data = {
          id: this.$route.query.id ? parseInt(this.$route.query.id) : undefined,
          title: datas.title,
          sign_model: '1',
          service_provider_id: datas.service_provider_id,
          // link_products:typeof(datas.link_products)=='number'?datas.link_products.toString(): datas.link_products.join(),
          budget: parseFloat(datas.money.budget),
		  // map_id:datas.datas,
          // deposit: parseInt(datas.money.deposit),
          province: datas.province_city.province,
          city: datas.province_city.city,
          path: `0,${datas.province_city.province},${datas.province_city.city},`,
          service_start_time: this.$Times(datas.service_time[0]),
          service_end_time: this.$Times(datas.service_time[1]),
          link_services,
        };
        this.btnIsLoading=true;
        let result=await this.$http.post(url, data);
        this.btnIsLoading=false;
        if (result.data.status === 1) {
          this.$message.success('操作成功！');
          this.$router.back();
        }
      }
    },
    // 取消
    onCancel() {
      this.$router.back();
    },
    // 点击checkbox
    handleChange(id, index) {
      this.servicesChecks[index].value = !this.servicesChecks[index].value;
      this.servicesChecks = JSON.parse(JSON.stringify(this.servicesChecks));
      const hasCheck = this.servicesChecks.some((item) => item.value);
      if (hasCheck) {
        this.errorMsg = '';
      }
    },
    // 自定义省市校验
    checkProvinceCity(rule, value, callback) {
      console.log('checkProvinceCity -> value', value);
      const error = [];
      if (!value || !value.province) {
        console.log(1213132123);
        error.push('省份');
      }
      if (error.length === 0) {
        callback();
      }
      callback('请选择省份');
    },
  },
};
</script>
<style lang="scss" scoped>
.cooperation-add-wrapper {
  .form-card-wrapper {
    .ant-card-body {
      display: block;
      padding-bottom: 0;
    }
  }
  .form-card-button {
    background: #f9f9fc;
    margin: 0 -32px -24px -32px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
      transform: translateY(10px);
  }
  .error-note {
    color: #f5222d;
    margin-left: 10px;
  }
}
</style>